import { BACKEND_URL_PREFIX } from '../assets/const';
import { createNotification } from '../components/Notifications/Notifications';
import { buildDefaultHeaders } from './helper';
import { getError } from '../utils/getError';
import {
  SET_USERS,
  SET_USERS_LOADING,
  SET_USERS_PAGE,
  SET_USER,
  SET_USER_LOADING
} from './types';

export const setPage = (pageNumber) => ({
  type: SET_USERS_PAGE,
  payload: {
    pageNumber: pageNumber,
  },
});

export const getUsers = () => async (dispatch, getState) => {
  dispatch({ type: SET_USERS_LOADING, payload: true });

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/user`, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });

    if (response.ok) {
      const data = await response.json();
      dispatch({ type: SET_USERS, payload: data });
    } else {
      const err = await response.json();
      createNotification('error', err?.msg || 'Ошибка загрузки пользователей');
      dispatch({ type: SET_USERS_PAGE, payload: [] });
    }
  } catch (error) {
    createNotification('error', 'Ошибка сети при загрузке пользователей');
  } finally {
    dispatch({ type: SET_USERS_LOADING, payload: false });
  }
};

export const getUser = (id) => async (dispatch, getState) => {
  dispatch({ type: SET_USER_LOADING, payload: true });

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/user/${id}`, {
      method: 'GET',
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });

    const data = await response.json();
    dispatch({ type: SET_USER, payload: data });
  } catch (error) {
    createNotification('error', 'Ошибка при загрузке пользователя');
  } finally {
    dispatch({ type: SET_USER_LOADING, payload: false });
  }
};

export const createUser = (data) => async (dispatch, getState) => {
  dispatch({ type: SET_USER_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/user`, {
      method: 'POST',
      body: JSON.stringify(data),
      ...buildDefaultHeaders(getState),
    });

    getError({ response, dispatch });

    if (response.ok) {
      createNotification('success', 'Успешно');
    } else {
      createNotification('error', 'Ошибка');
    }
  } catch (error) {
    createNotification('error', 'Ошибка');
  } finally {
    await dispatch(getUsers());
  }
  dispatch({ type: SET_USER_LOADING, payload: false });
};

export const updateUser = (id, data) => async (dispatch, getState) => {
  dispatch({ type: SET_USERS_LOADING, payload: true });
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/user/${id}`, {
      method: 'PUT',
      headers: {
        ...buildDefaultHeaders(getState).headers,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    getError({ response, dispatch });

    const result = await response.json();

    if (response.ok) {
      createNotification('success', 'Данные пользователя обновлены!');
      return { success: true, user: result };
    } else {
      createNotification('error', result?.error || 'Ошибка обновления');
      return { success: false };
    }
  } catch (error) {
    createNotification('error', 'Ошибка сети при обновлении пользователя');
    return { success: false };
  } finally {
    dispatch({ type: SET_USERS_LOADING, payload: false });
  }
};

export const deleteUser = (id) => async (dispatch, getState) => {
  dispatch({ type: SET_USER_LOADING, payload: true });

  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/user/${id}`, {
      method: 'DELETE',
      ...buildDefaultHeaders(getState),
    });

    const resData = await response.json().catch(() => ({})); // безопасный парсинг JSON

  getError({ response, dispatch });

    if (response.ok) {
      createNotification('success', 'Пользователь удалён');
      return resData; // ✅ возвращаем ответ, чтобы можно было использовать в компоненте
    } else {
      createNotification('error', resData?.error || 'Ошибка удаления');
      return { success: false };
    }
  } catch (error) {
    createNotification('error', 'Ошибка сети');
    return { success: false };
  } finally {
    dispatch({ type: SET_USER_LOADING, payload: false });
    await dispatch(getUsers());
  }
};

export const changePassword = (payload) => async (dispatch, getState) => {
  try {
    const response = await fetch(`${BACKEND_URL_PREFIX}/auth/password`, {
      method: 'POST',
      headers: {
        ...buildDefaultHeaders(getState).headers,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(payload),
    });

    getError({ response, dispatch });

    const result = await response.json();

    if (response.ok) {
      createNotification('success', 'Пароль успешно изменён!');
      console.log('✅ Password changed for user:', result);
      return { success: true };
    }

    // Ошибки
    if (result?.error) {
      createNotification('error', result.error || 'Ошибка при смене пароля');
    } else {
      createNotification('error', 'Не удалось изменить пароль');
    }

    return { success: false };
  } catch (error) {
    createNotification('error', 'Ошибка сети при смене пароля');
    return { success: false };
  }
};
